import React from 'react';
import { ABLE_COLORS } from '../../constants';
import { renderMarkdown } from '../../utils/markdown';

/**
 * ChatMessage - Single message bubble in chat
 * Renders user or assistant messages with markdown support
 */
export default function ChatMessage({ message }) {
  const isUser = message.role === 'user';
  
  return (
    <div
      style={{
        alignSelf: isUser ? 'flex-end' : 'flex-start',
        maxWidth: '80%',
        padding: '12px',
        borderRadius: '12px',
        backgroundColor: isUser ? ABLE_COLORS.accent : 'white',
        boxShadow: isUser ? 'none' : '0 1px 3px rgba(0,0,0,0.06)',
        color: isUser ? 'white' : '#333'
      }}
    >
      <div style={{ 
        lineHeight: '1.5',
        wordBreak: 'break-word'
      }}>
        {renderMarkdown(message.content)}
      </div>
      {message.suggestedTasks && message.suggestedTasks.length > 0 && (
        <div style={{ marginTop: '8px', fontSize: '12px', opacity: 0.8 }}>
          Suggested: {message.suggestedTasks.join(', ')}
        </div>
      )}
    </div>
  );
}
